import { formatMessage } from "i18n/CurrentLocale";
import { FormattedMessage } from "react-intl";
import placeholders from "string-translations/placeholders";


export const InputAcceptTC = (props: Props) => {
    return (
        <div className="checkbox-with-label">
            <div data-testid="checkbox-terms-and-conditions" className={`myparkd-checkbox ${props.getClassNames('acceptedTC')}`}
                onClick={() => props.onClickAcceptTerms()}
            >
                {props.acceptedTC && <div className="checkmark" />}
            </div>
            <p className="checkbox-text" onClick={() => props.onClickAcceptTerms()}>
                <FormattedMessage id="REGISTRATION_CLICK_TO_ACCEPT" />
                &nbsp;
                <a href={formatMessage(placeholders.parkdTermsConditionsURL)} target="_blank" rel="noreferrer">
                    <FormattedMessage id="REGISTRATION_TERMS_AND_CONDITIONS" />
                </a>
            </p>
        </div>
    )
}

type Props = {
    onClickAcceptTerms: Function,
    acceptedTC: boolean,
    getClassNames: Function,
}
